module.exports = __webpack_public_path__ + "static/talentminded-logo-b7bd8d9373eb848070e56c33fc0a930d.jpeg";